import React from 'react';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export default function SlideThumbnailList({ deck, deckId, previewImages, activeSlide, onSelect }) {
  if (!deck) return null;

  const allSlides = [
    { title: deck.title, layout: 'cover', subtitle: deck.subtitle },
    { title: 'Executive Summary', layout: 'content', bullets: [deck.executive_summary] },
    ...(deck.slides || [])
  ];

  return (
    <div className="thumbnail-list">
      {allSlides.map((slide, i) => {
        const hasImage = previewImages && previewImages[i];
        return (
          <div
            key={i}
            className={`thumbnail ${activeSlide === i ? 'thumbnail--active' : ''}`}
            onClick={() => onSelect(i)}
            role="button"
            tabIndex={0}
            aria-label={`Slide ${i + 1}: ${slide.title}`}
          >
            {hasImage ? (
              <img
                src={`${API}/preview/${deckId}/${previewImages[i]}`}
                alt={`Slide ${i + 1}`}
                className="thumbnail__img"
              />
            ) : (
              <div className="thumbnail__card">
                <span className="thumbnail__number">{i + 1}</span>
                <span className="thumbnail__title">{slide.title}</span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
